import { Box, TextField, Button, useMediaQuery } from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import axios from "axios"; 
import Header from "../../Components/Common/Header";
import homeBanner from "../../Assets/Images/home-banner.png";
import PerfectEscape from "../../Components/Home/PerfectEscape";
import Container from "../../Components/Layout/Container";
import Card from "../../Components/Common/Card";
import Heading from "../../Components/Common/Heading";
import BottomBanner from "../../Components/Home/BottomBanner";
import Navbar from "../../Components/Common/Navbar";
import Footer from "../../Components/Common/Footer";
import { BASE_URL } from "../../Assets/Constants";
import { CurrencyContext } from "../../Services/CurrencyContext";
import { toast } from "react-toastify";

function Home() {
  const { currency } = useContext(CurrencyContext);
  const [showSearch, setShowSearch] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [topDestinations, setTopDestinations] = useState([]);
  const [topExperiences, setTopExperiences] = useState([]);
  const [trendingExperiences, setTrendingExperiences] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setShowSearch(false);
      } else {
        setShowSearch(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/user/home`, {
        currencysymbol: currency,
      });

      
      if (response.data.success) {
        setTopDestinations(response.data.Top_Destinations || []);
        setTopExperiences(response.data.Top_Experiences || []);
        setTrendingExperiences(response.data.Trending_Experiences || []);
      }
    } catch (error) {
      console.error("Error fetching data from API:", error?.response);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currency]);

  if (loading) {
    return (
      <>
        <style>{loaderStyle.spinnerAnimation}</style>
        <div style={loaderStyle.loaderContainer}>
          <div style={loaderStyle.spinner}></div>
        </div>
      </>
    );
  }

  const filterData = (data) => {
    return data.filter((item) =>
      item?.name?.toLowerCase().includes(searchQuery.toLowerCase())
    );
  };


  return (
    <>
      <Navbar currency={currency} searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
      <Box>
        <Header
          banner={homeBanner}
          label1={"Unlock Moments of Wonder"}
          label2={
            "Discover handpicked journeys that inspire, refresh, and leave you longing for more."
          }
          button={true}
        />
        <Container>
          <Box my={5}>
            <PerfectEscape />
          </Box>

          <Box textAlign={"center"} mt={10} mb={4}>
            <Heading label={"Top Destinations"} size="64px" />
          </Box>
          {filterData(topDestinations).length > 0 ? <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(1, 1fr)",
                sm: "repeat(2, 1fr)",
                md: "repeat(6, 1fr)",
              },
              gap: 3,
              "@media (min-width: 900px) and (max-width: 1300px)": {
                gridTemplateColumns: "repeat(3, 1fr)",
              },
              "@media (min-width: 1280px) and (max-width: 1366px)": {
                gridTemplateColumns: "repeat(6, 1fr)",
              },
            }}
          >
            {filterData(topDestinations).map((destination, index) => (
              <Card key={index} data={destination} />
            ))}
          </Box> : <Box textAlign="center" mt={5} color="gray">
            No experiences found!
          </Box>}

          <Box textAlign={"center"} mt={10} mb={4}>
            <Heading label={"Top Experiences"} size="64px" />
          </Box>
          {filterData(topExperiences).length > 0 ? <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(1, 1fr)",
                sm: "repeat(2, 1fr)",
                md: "repeat(6, 1fr)",
              },
              gap: 3,
              "@media (min-width: 900px) and (max-width: 1300px)": {
                gridTemplateColumns: "repeat(3, 1fr)",
              },
              "@media (min-width: 1280px) and (max-width: 1366px)": {
                gridTemplateColumns: "repeat(6, 1fr)",
              },
            }}
          >
            {filterData(topExperiences).map((experience, index) => (
              <Card key={index} data={experience} />
            ))}
          </Box> : <Box textAlign="center" mt={5} color="gray">
            No experiences found!
          </Box>}


          <Box textAlign={"center"} mt={10} mb={4}>
            <Heading label={"Trending Experiences"} size="64px" />
          </Box>
          {filterData(trendingExperiences).length > 0 ? <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(1, 1fr)",
                sm: "repeat(2, 1fr)",
                md: "repeat(6, 1fr)",
              },
              gap: 3,
              "@media (min-width: 900px) and (max-width: 1300px)": {
                gridTemplateColumns: "repeat(3, 1fr)",
              },
              "@media (min-width: 1280px) and (max-width: 1366px)": {
                gridTemplateColumns: "repeat(6, 1fr)",
              },
            }}
          >
            {filterData(trendingExperiences).map((experience, index) => (
              <Card key={index} data={experience} />
            ))}
          </Box> : <Box textAlign="center" mt={5} color="gray">
            No experiences found!
          </Box>}

          <Box my={5}>
            <BottomBanner />
          </Box>
        </Container>
      </Box>
      <Footer />
    </>
  );
}

const loaderStyle = {
  loaderContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f9f9f9",
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "5px solid rgba(0, 0, 0, 0.1)",
    borderTop: "5px solid #FF7900",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  spinnerAnimation: `
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `,
};

export default Home;
